import { HttpClient } from "@angular/common/http";
import { Injectable, Output, EventEmitter } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

const state = {
  checkoutItems: JSON.parse(localStorage["checkoutItems"] || "[]"),
};

@Injectable({
  providedIn: "root",
})
export class OrderService {
  constructor(private router: Router, private http: HttpClient) {}
  mail: string;

  private sharedId: number;
  // Get Checkout Items
  public get checkoutItems(): Observable<any> {
    const itemsStream = new Observable((observer) => {
      observer.next(state.checkoutItems);
      observer.complete();
    });
    return <Observable<any>>itemsStream;
  }

  // Create order
  public createOrder(product: any, details: any, orderId: any, amount: any) {
    var item = {
      shippingDetails: details,
      product: product,
      orderId: orderId,
      totalAmount: amount,
    };
    state.checkoutItems = item;
    localStorage.setItem("checkoutItems", JSON.stringify(item));
    sessionStorage.removeItem("cartItems");
    this.router.navigate(["/shop/checkout/success", orderId]);
  }

  //Enviar ID orden
  getSharedId(): number {
    return this.sharedId;
  }

  setSharedId(id: number): void {
    this.sharedId = id;
  }

  traerOrden(idOrden: number) {
    return this.http.get(
      environment.API_SECURITY + "/api/Ordenes/obtenerOrdenById/" + idOrden
    );
  };
  

  getSharedMail(): string {
    return this.mail;
  }

  setSharedMail(mail: string): void {
    this.mail = mail;
  }
}
